import { memo } from "react"
import {LockedSplitLayout} from "./LockedSplitLayout"

export const LeftNavLayout = memo(({ children }: { children: [JSX.Element, JSX.Element] }) => {
  const leftWidth = 300
  return (
    <LockedSplitLayout lockedSide="left" lockedSize={leftWidth + "px"}>
      {children[0]}
      {children[1]}
    </LockedSplitLayout>
  )
})


